import { Controller } from "@hotwired/stimulus"
import { CurrencyHelper } from "~/helpers/currency_helper"

export default class extends Controller {
  static targets = [
    "countryCode", "postalCode", "currency", "subtotalLine", "subtotalAmount",
    "taxLine", "taxAmount", "totalAmount", "state", "payButton"
  ]

  static values = { subtotal: Number }

  initialize() {
    let _this = this
    _this.payButtonTarget.setAttribute("disabled", "true")
    _this.calculate()

    // The postal code might be updated programmatically (for example through
    // the autocomplete). Therefore, we can't rely on Stimulus to notice the
    // changes.
    $(this.countryCodeTarget).on("change", function () {
      // A small delay ensures the autocomplete has finished setting the values
      // to the DOM.
      setTimeout(function () {
        _this.calculate()
      }, 300)
    })
  }

  calculate() {
    this.postalCodeTarget.value = this.postalCodeTarget.value.trim()

    // The Sales tax only applies to the US.
    if (this.countryCodeTarget.value != "US" || this.postalCodeTarget.value == "") {
      this.removeTaxInformation()
      return
    }

    var _this = this

    fetch(`/subscriptions/tax-rate?country=${this.countryCodeTarget.value}&zip_code=${this.postalCodeTarget.value}`, {
      credentials: "same-origin",
    })
      .then(response => response.json())
      .then(response => {
        if (response.error != null) {
          console.warn(`Failed fetching tax rate: ${response.error}`)
          return
        }

        console.info(`Sales tax rate: ${JSON.stringify(response)}`)

        if (response.tax_rate == 0.0) {
          _this.removeTaxInformation()
          return
        }

        let subtotal = parseFloat(_this.subtotalValue)
        let salesTax = CurrencyHelper.numberToCurrency(subtotal * response.tax_rate, _this.currency())
        let total = CurrencyHelper.numberToCurrency(subtotal + subtotal * response.tax_rate, _this.currency())

        _this.stateTarget.innerHTML = response.state
        _this.subtotalAmountTarget.innerHTML = CurrencyHelper.numberToCurrency(subtotal, _this.currency())
        _this.taxAmountTarget.innerHTML = salesTax
        _this.totalAmountTarget.innerHTML = total

        _this.payButtonTarget.removeAttribute("disabled")
        _this.taxLineTarget.classList.remove("d-none")
        _this.subtotalLineTarget.classList.remove("d-none")
      })
  }

  // If a user selects another country than the US, or a State for which we
  // don't collect the Sales Tax, we remove any tax information.
  removeTaxInformation() {
    this.payButtonTarget.removeAttribute("disabled")
    this.taxLineTarget.classList.add("d-none")
    this.subtotalLineTarget.classList.add("d-none")

    this.totalAmountTarget.innerHTML = CurrencyHelper.numberToCurrency(this.subtotalValue, this.currency())
  }

  // If the billing information are complete, the currency is fetched from the
  // hidden input. Else, it's fetched from the select, with two cases:
  //   - from the selected option if any option is selected
  //   - else, from the fallback value.
  currency() {
    if (this.hasCurrencyTarget) {
      return this.currencyTarget.value
    }

    var currencyFromSelect = $(this.countryCodeTarget).find(":selected").data("currency")
    if (currencyFromSelect != undefined) {
      return currencyFromSelect
    }

    return $(this.countryCodeTarget).data("fallback-currency")
  }
}
